'use strict'

import React, { useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Modal from 'components/shared/modal/wide'
import BodyClass from 'components/shared/body-class'
import 'react-image-crop/dist/ReactCrop.css';
import ImageEditor from '@toast-ui/react-image-editor'

import 'tui-image-editor/dist/tui-image-editor.css'
import * as uploadTypes from 'actions/uploader/types';

const icona = require('tui-image-editor/dist/svg/icon-a.svg');
const iconb = require('tui-image-editor/dist/svg/icon-b.svg');
const iconc = require('tui-image-editor/dist/svg/icon-c.svg');
const icond = require('tui-image-editor/dist/svg/icon-d.svg');

const myTheme = {
  'menu.backgroundColor': 'white',
  'common.backgroundColor': '#151515',
  'downloadButton.backgroundColor': 'white',
  'downloadButton.borderColor': 'white',
  'downloadButton.color': 'black',
  'menu.normalIcon.path': icond,
  'menu.activeIcon.path': iconb,
  'menu.disabledIcon.path': icona,
  'menu.hoverIcon.path': iconc,
};


const ImageEditorModal = ({ image, imageEditorObj, showHideEditor, onSaveEditedImage, index, updateImageEdited }) => {
  const imageEditor = useRef()

  const onClickSave = async () => {
    const imageEditorInst = imageEditor.current.imageEditorInst;
    const data = imageEditorInst.toDataURL();
    const imageName = imageEditorObj.path
    const url = await onSaveEditedImage({ data, imageName })

    showHideEditor()
    imageEditorObj.path = url
    updateImageEdited(index, imageEditorObj)
  }

  return (
    <Modal className="modal-container-gallery bg-white w-full mx-auto rounded shadow-lg z-50 h-screen overflow-auto">
      <BodyClass className="modal-open gallery-modal"/>
      <div className={`w-full h-full flex flex-col`}>
        <div className={`w-full flex justify-end p-2`}>
          <button
            className={`btn px-5 text-xs focus:outline-none outline-none`}
            onClick={showHideEditor}
          >
            Cancel
          </button>
          <button
            className={`btn btn-primary px-5 text-xs focus:outline-none outline-none`}
            onClick={onClickSave}
          >Save
          </button>
        </div>
        <div className={`w-full flex-1`}>
          <ImageEditor ref={imageEditor}
            includeUI={{
              loadImage: {
                path: image,
                name: 'SampleImage'
              },
              theme: myTheme,
              menu: ['crop', 'flip', 'rotate'],
              initMenu: '',
              uiSize: {
                width: window.innerWidth,
                height: window.innerHeight
              },
              menuBarPosition: 'bottom'
            }}
            cssMaxHeight={window.innerHeight}
            cssMaxWidth={window.innerWidth}
            selectionStyle={{
              cornerSize: 20,
              rotatingPointOffset: 70
            }}
            usageStatistics={true}
          />
        </div>
      </div>
    </Modal>
  )
}

ImageEditorModal.propTypes = {
  image: PropTypes.string,
  imageEditorObj: PropTypes.obj,
  showHideEditor: PropTypes.func,
  onSaveEditedImage: PropTypes.func,
  index: PropTypes.number,
  updateImageEdited: PropTypes.func
}

const mapDispatchToProps = dispatch => ({
  onSaveEditedImage: (payload) => new Promise((resolve, reject) => {
    dispatch({ type: uploadTypes.UPLOAD_EDITED_IMAGE, payload, resolve, reject });
  }),
  dispatch
})


export default connect(null, mapDispatchToProps)(ImageEditorModal)
